import { RedoShopifyDeliveryMethodType } from "@redotech/redo-fulfillment-group-common/fulfillment-delivery-method-type";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { canPurchaseLabelStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { useTranslation } from "@redotech/redo-i18n";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { isLabelPurchasable } from "./label-purchase-selection";

export interface LabelPurchaseWarningProps {
  fulfillmentGroups: readonly FulfillmentGroupData[];
  inset?: boolean;
}

export const LabelPurchaseWarning = memo(function LabelPurchaseWarning({
  fulfillmentGroups,
  inset = false,
}: LabelPurchaseWarningProps) {
  const { t } = useTranslation();
  const skippedGroups = fulfillmentGroups.filter(
    (group) =>
      group.deliveryMethod === RedoShopifyDeliveryMethodType.Shipping &&
      canPurchaseLabelStatus(group.status) &&
      !group.ratesPendingSince &&
      !isLabelPurchasable(group),
  );
  if (skippedGroups.length === 0) {
    return null;
  }
  const count = skippedGroups.length;
  return (
    <Text
      fontSize="xs"
      px={inset ? "3xl" : "none"}
      py={inset ? "md" : "none"}
      textAlign={inset ? "left" : "right"}
      textColor="error"
    >
      {count === 1
        ? t("1 order without an available rate will be skipped.")
        : t("{{count}} orders without an available rate will be skipped.", {
            count,
          })}
    </Text>
  );
});
